import React, { useEffect, useState } from "react";
import {
  SlDrawer,
  SlIcon
} from "@shoelace-style/shoelace/dist/react";
import { useForm } from "react-hook-form";
import API from "../../services/api";
import { Toast } from "../../shared/Toast";
function CampaignInfo(props) {
  const [selectedRows, setSelectedRows] = useState([]);
  const [newspaperData, setNewsPaperData] = useState([]);
  const [minDate, setMinDate] = useState("");
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const languages = {
    "0": "All",
    "1": "Telugu",
    "2": "Tamil",
    "3": "Hindi",
    "4": "Kannada",
    "5": "Malayalam",
    "6": "Marathi",
    "7": "Bengali",
    "8": "Gujarati",
    "9": "Punjabi",
    "10": "Oria",
    "11": "English",
    "13": "Telugu-English"
  }
  
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onTouched" });
  const fetchNewsPapers = async() =>{
    try {
      let res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType:'json',
        data:{}
      })
      if(res.code === 200){
        setNewsPaperData([...res.data])
      }
    } catch (error) {
      console.error(error)
    }
  }
  const onSubmit = async (data) => {
    try {
      let res = await API({
        url: "/accountManagement/campaign_info",
        method: "POST",
        responseType: "json",
        data: {
          brand_id:props.brand.brand_id,
          campaign_date: data.campaign_date,
          // campaign_title: data.campaign_title,
          target_platform: selectedRows, // selected sources of campaign ex: ['sakshi', 'eenadu']
        },
      });
      if (res.code === 200) {
        Toast("success", "Info added successfully!");
        props.setShow(false)
      }
      else{
        Toast('error', res.data?.message)
      }
    } catch (error) {
      console.error(error);
    }
  };
  // When the selected option is not present it will be add or else it will be removed.

  const handleCheckboxChange = (source) => {
    setSelectedRows((prevSelectedRows) => {
      const index = prevSelectedRows.findIndex((item) => item === source);
      if (index !== -1) {
        return prevSelectedRows.filter((item, idx) => idx !== index);
      } else {
        return [...prevSelectedRows, source];
      }
    });
  };
  useEffect(() => {
    fetchNewsPapers()
  }, [])
  useEffect(() => {
    const now = new Date();
    const cutoff = new Date();
    cutoff.setHours(4, 0, 0, 0); // Set to 4:00 AM today
  
    if (now < cutoff) {
      // Before 4 AM: allow today
      setMinDate(now.toISOString().split("T")[0]);
    } else {
      // After 4 AM: only allow from tomorrow
      const tomorrow = new Date(now);
      tomorrow.setDate(tomorrow.getDate() + 1);
      setMinDate(tomorrow.toISOString().split("T")[0]);
    }
  }, []);
  return (
    <div>
      <SlDrawer
        label="POC"
        open={props.show}
        onSlRequestClose={handleRequestClose}
        noHeader={true}
        // contained={true}
        // placement="bottom"
        // style={{ "--size": "" }}
      >
        <div className="px-2 pt-2 relative">
          <h3>Competition Known Campaign</h3>
          <p className="text-gray-500 text-xs my-3">{props.brand.name}</p>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-3">
              <label className="form-label">Date</label>
              <input
                type="date"
                min={minDate}
                className="form-control"
                {...register("campaign_date", {
                  required: { value: true, message: "Date is required!" },
                })}
              ></input>
              {errors.campaign_date && (
                <p className="text-red-600">{errors.campaign_date.message}</p>
              )}
            </div>
            {/* <div className="mb-3">
            <label className="form-label">Campaign Title</label>
              <input
                className="form-control"
                placeholder="Campaign Title"
                {...register("campaign_title", {
                  required: { value: true, message: "Title is required!" },
                })}
              ></input>
              {errors.campaign_title && (
                <p className="text-red-600">{errors.campaign_title.message}</p>
              )}
            </div> */}
            <div className="border-b-[2px] border-dotted mb-3"></div>
            <p className="font-bold my-2">Target Platform</p>
            <p className="text-xs text-gray-500 mb-1">
              Can Select multiple platforms
            </p>
            <div className="mb-3">
              {newspaperData.map((np) =>{ return(
                <>
               {np.name !== "Way2news" ? <div class="form-check" key={np.id}>
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id={np.id.toLowerCase()}
                  {...register(np.name, {
                    required: {
                      value: selectedRows.length === 0,
                      message: "Choose at least one",
                    },
                    onChange: () => {
                      handleCheckboxChange(np.name);
                    },
                  })}
                />
                <label class="form-check-label" for={np.id.toLowerCase()}>
                  {np.name} - {languages[np.language]}
                </label>
              </div> : null}
                </>
              )})}

              {Object.values(errors).length > 0 && !errors.campaign_title && !errors.campaign_date && (
              <p className="text-red-600">Choose at least one from above</p>
            )}
            </div>
            <div>
              <button
                className="w-100 bg-[#0079BC] px-4 py-3 text-white font-bold   text-xs rounded "
                type="submit"
              >
                Save Details
              </button>
            </div>
          </form>
          <SlIcon
            className="absolute top-3 right-6 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => props.setShow(false)}
          ></SlIcon>
        </div>
      </SlDrawer>
    </div>
  );
}

export default CampaignInfo;
